module.exports = "<div class=\"container\">\n    <app-page-contents [pageName]=\"pageName\"></app-page-contents>\n    <br>\n    <ul class=\"list-group\">\n        <li class=\"list-group-item\" *ngFor=\"let structure of ceStructureTree\">\n            <a routerLink=\"/edition/sample/{{structure.id}}\">Sample - {{structure.name}}</a>\n        </li>\n    </ul>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-critical-edition-samples/page-critical-edition-samples.component.html
// module id = ./src/app/components/pages/page-critical-edition-samples/page-critical-edition-samples.component.html
// module chunks = main